export class ShippingMean {
    id: number;
    description: string;
    status: number;
    country: any;
    shippingType: any;
}
